module.exports = __webpack_public_path__ + "img/agent_machine.b1437d6f.png";